import React, { useRef, useState, useEffect } from 'react';

export function FrameWrapper({ html }) {
    const ref = useRef();
    const [height, setHeight] = useState('0px');

    const onLoad = () => {
        // documentElement, not body: body.scrollHeight leaves out the body's own
        // default margins, and with scrolling="no" that cut off the last line of
        // short emails (a Support Inbox auto reply's signature, STAFFPROJE-95).
        setHeight(`${ref.current.contentWindow.document.documentElement.scrollHeight + 10}px`);
    };
    useEffect(() => {
        onLoad();
    }, []);

    return (
        <iframe
            ref={ref}
            onLoad={onLoad}
            className="w-full"
            id="emailtimelineiframe"
            srcDoc={html}
            // The iframe document is transparent, so without this a dark theme
            // card shows through behind the email's default black text.
            style={{ background: 'var(--email-canvas)' }}
            height={height}
            scrolling="no"
            frameBorder="0"
        />
    );
}